/**
 * ValetIcon - Maestro "M" music note icon
 *
 * IMPORTANT: This must match the app icon/favicons for consistency.
 */

import React from 'react';
import maestroIcon from '../../assets/icons/Maestro-Favicon.png';

export const ValetIcon = ({ size = 24, className = '', src = maestroIcon }) => (
  <img
    src={src}
    alt=""
    aria-hidden="true"
    draggable={false}
    className={`inline-block select-none ${className}`}
    style={{ width: size, height: size }}
  />
);

export const ValetIconCircle = ({ size = 40, className = '' }) => (
  <ValetIcon size={size} className={className} />
);

export default ValetIcon;
